import React__default from 'react';
import classnames from 'classnames';
import CSS from './index.module.scss.js';
import { categoryMap } from '../config.js';
import { VerticalSelector } from '../VerticalSelector.js';
import { CategoryList } from '../CategoryList.js';
import { getMacroCategory } from '../getPageMacroCategory.js';

function Modal({ show, onClose, useCloseArrow = true, className, assetsBase, categoryId, setCategoryInput, }) {
    const [showWithAnimation, setShowWithAnimation] = React__default.useState(false);
    const [verticalActive, setVerticalActive] = React__default.useState(undefined);
    const [verticalClicked, setVerticalClicked] = React__default.useState(categoryMap.motori);
    const [selectedCategoryId, setSelectedCategoryId] = React__default.useState();
    const onClickClose = function () {
        // We set the value undefined so that when we re-open the modal we don't see for an instant the last selected element before closure
        setVerticalActive(undefined);
        onClose();
    };
    // We set the category based on item selected not based on the category focused at the moment of the selection
    React__default.useEffect(() => {
        if (categoryId) {
            setSelectedCategoryId(categoryId);
            setVerticalClicked(getMacroCategory(categoryId));
            setVerticalActive(getMacroCategory(categoryId));
        }
    }, [categoryId]);
    React__default.useEffect(() => {
        const action = show ? 'add' : 'remove';
        document.body.classList[action]('modal-open');
        const id = window.requestAnimationFrame(() => {
            setShowWithAnimation(show);
        });
        return () => {
            window.cancelAnimationFrame(id);
            document.body.classList.remove('modal-open');
        };
    }, [show]);
    React__default.useEffect(() => {
        const closeModal = (e) => {
            if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
                onClose();
            }
        };
        window.addEventListener('keydown', closeModal);
        return () => {
            window.removeEventListener('keydown', closeModal);
        };
    }, [onClose]);
    const onCloseCb = React__default.useCallback((input) => {
        setCategoryInput(input);
        setSelectedCategoryId(input?.key);
        onClose();
    }, [onClose, setCategoryInput]);
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    React__default.createElement("div", { className: classnames(className, CSS['modal'], showWithAnimation ? CSS['isVisible'] : null), hidden: !show, onClick: onClickClose },
        React__default.createElement("div", { className: classnames(CSS['modal-content'], useCloseArrow ? CSS['close-arrow-active'] : null), onClick: (e) => e.stopPropagation() },
            React__default.createElement("button", { className: classnames(CSS['close'], CSS['close-x']), "aria-label": "Chiudi la modale", onClick: onClickClose },
                React__default.createElement("svg", { className: "close-x-modal", width: "24", height: "24", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                    React__default.createElement("path", { d: "M13.4017611,12 L19.7096858,18.3079247 C20.0967714,18.6950104 20.0967714,19.3226002 19.7096858,19.7096858 C19.3226002,20.0967714 18.6950104,20.0967714 18.3079247,19.7096858 L12,13.4017611 L5.69207527,19.7096858 C5.30498964,20.0967714 4.67739984,20.0967714 4.29031422,19.7096858 C3.90322859,19.3226002 3.90322859,18.6950104 4.29031422,18.3079247 L10.5982389,12 L4.29031422,5.69207527 C3.90322859,5.30498964 3.90322859,4.67739984 4.29031422,4.29031422 C4.67739984,3.90322859 5.30498964,3.90322859 5.69207527,4.29031422 L12,10.5982389 L18.3079247,4.29031422 C18.6950104,3.90322859 19.3226002,3.90322859 19.7096858,4.29031422 C20.0967714,4.67739984 20.0967714,5.30498964 19.7096858,5.69207527 L13.4017611,12 Z" }))),
            React__default.createElement("button", { className: classnames(CSS['close'], CSS['close-arrow']), onClick: onClickClose, "aria-label": "Chiudi la modale" },
                React__default.createElement("img", { src: `${assetsBase}/static/icons/cactus/arrow-down.svg`, width: "24", height: "24", alt: "" })),
            React__default.createElement("div", { className: CSS['modal-inner'] },
                React__default.createElement("div", { className: CSS['modal-sx'] },
                    React__default.createElement(VerticalSelector, { verticalActive: verticalActive, setCategoryInput: onCloseCb, verticalClicked: verticalClicked, setVerticalClicked: setVerticalClicked })),
                React__default.createElement("div", { className: CSS['modal-dx'] },
                    React__default.createElement(CategoryList, { selectedCategoryId: selectedCategoryId, setVerticalActive: setVerticalActive, setCategoryInput: onCloseCb, assetsBase: assetsBase }))))));
}

export { Modal };
//# sourceMappingURL=index.js.map
